import { Container } from './styles'

export function FilterRoot({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
